import { motion } from "framer-motion";
import { VIDEOS } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";

export const VideoFrame = ({ src, title, testId }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.96, y: 40 }}
    whileInView={{ opacity: 1, scale: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
    className="relative"
    data-testid={testId}
  >
    <div className="absolute -inset-px border border-gold/40 -translate-x-3 -translate-y-3 pointer-events-none" />
    <div className="absolute -inset-px border border-gold/15 translate-x-3 translate-y-3 pointer-events-none" />
    <div className="relative aspect-video bg-ink border border-gold/20 shadow-[0_30px_80px_rgba(0,0,0,0.55)]">
      <iframe
        className="absolute inset-0 h-full w-full"
        src={src}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  </motion.div>
);

export const Film = () => (
  <section id="film" className="relative py-28 lg:py-40" data-testid="film-section">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
        <SectionHead index="01" eyebrow="The Film" title={<>Real estate, <em className="not-italic text-gold">professionally</em> sourced.</>} className="lg:col-span-7" />
        <Reveal delay={0.2} className="lg:col-span-4 lg:col-start-9">
          <p className="text-ivory/60 leading-relaxed">
            An introduction to how Bossard Investment Group turns undervalued property into income, equity and tax
            advantage — for investors who would rather own the asset than the workload.
          </p>
        </Reveal>
      </div>
      <VideoFrame src={VIDEOS.film} title="Bossard Investment Group — Introduction" testId="film-video" />
      <Reveal delay={0.2} className="mt-8 flex items-center justify-between text-xs font-mono uppercase tracking-[0.25em] text-ivory/40">
        <span>Bossard Investment Group LLC</span>
        <span>Investor Introduction — 2026</span>
      </Reveal>
    </div>
  </section>
);
